import {Injectable} from '@angular/core';
import {NotificationsState, NotificationsStore} from './notifications.store';
import {NotificationsQuery} from './notifications.query';
import {HttpClient, HttpErrorResponse, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {NotificationModel} from '../../models/notification.model';
import {Pagination} from '../../models/pagination.model';
import {ID} from '@datorama/akita';

@Injectable({providedIn: 'root'})
export class NotificationsService {

  constructor(private _notificationsStore: NotificationsStore,
              private _notificationsQuery: NotificationsQuery,
              private _http: HttpClient) {
  }

  get() {
    this.setLoading(true);
    this._http.get(`${environment.apiRoot}/agriscouting/api/notifications`)
      .subscribe(
        (response: Pagination<NotificationModel>) => {
          this.setLoading(false);
          this._notificationsStore.set(response.content);
        },
        (err: HttpErrorResponse) => {
          this.setLoading(false);
          this.setError(err);
        }
      );
  }

  getMapUnitParents(fieldId: ID, cropYear: string) {
    const params = new HttpParams()
      .set('size', '100')
      .set('cropYear', cropYear)
      .set('fieldId', fieldId.toString());
    return this._http.get(`${environment.apiRoot}/agriscouting/api/mapUnits/parents`, {params});
  }

  markAsReaded(ids: ID[]) {
    const data = ids.map((id: ID) => {
      return {id: id, readed: true};
    });
    this._http.put(`${environment.apiRoot}/agriscouting/api/notifications`, data)
      .subscribe(
        () => this.get(),
        (err: HttpErrorResponse) => this.setError(err)
      );
  }

  setSelectedDate(date: Date) {
    this._notificationsStore.updateRoot({planningSelectedDate: date});
  }

  getPlanningSelectedDate(): Date {
    return this._notificationsQuery.getValue().planningSelectedDate;
  }

  setLoading(value: boolean) {
    this._notificationsStore.setLoading(value);
  }

  setError(error: HttpErrorResponse) {
    this._notificationsStore.setError(error);
  }

  saveParents(fieldId: string, parents: string) {
    this._notificationsStore.updateRoot((state: NotificationsState) => {
      const savedParents = {...state.savedParents};
      savedParents[fieldId] = parents;
      return {
        ...state,
        savedParents
      };
    });
  }

  getSavedParents(fieldId: string): string {
    return this._notificationsQuery.getValue().savedParents[fieldId];
  }

  getActiveReportTab(): number {
    return this._notificationsQuery.getValue().selectedReportTab || 0;
  }

  setActiveReportTab(tabNumber: number) {
    this._notificationsStore.updateRoot({selectedReportTab: tabNumber});
  }
}
